// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e1fb086","453":"817ff6b0","732":"98b1dcad","977":"44b8dde9"}[chunkId] + ".chunk.js";
};